<script setup>
  const props = defineProps({
    whiteCorner: Object,
    blackCorner: Object,
    whiteCornerWin: Boolean,
    blackCornerWin: Boolean,
    withdrawn: Boolean,
    large: Boolean,
  });
</script>

<!----------------------------------------------------------------------------->

<template>
  <div class="fighters">
    <PastEventFighter
      :fighter="props.whiteCorner"
      :forceActive="!props.whiteCornerWin && !props.blackCornerWin"
      :winner="props.whiteCornerWin"
      :large="props.large"
      inWhiteCorner
    />
    <PastEventFighter
      :fighter="props.blackCorner"
      :forceActive="!props.whiteCornerWin && !props.blackCornerWin"
      :winner="props.blackCornerWin"
      :large="props.large"
      :withdrawn="props.withdrawn"
    />
  </div>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  .fighters {
    position: relative;

    display: flex;
    border: px(1) solid $black-5;

    > * {
      &:first-child {
        border-right: px(1) solid $black-5;
      }
    }

    &:after {
      content: 'vs';
      @include heroic-bold(px(29));

      position: absolute;
      z-index: 10;

      pointer-events: none;

      left: 50%;
      top: calc(50% - px(36)); // half .name bar

      transform: translate(-50%, -50%);
      background-color: $black;

      padding: px(5) px(4.5) px(1);

      @include break-small {
        top: calc(50% - px(40)); // half .name bar
        font-size: px(22);
      }

      @include break-phone {
        top: calc(50% - px(30)); // half .name bar
        font-size: px(20);
      }
    }
  }
</style>
